import React from 'react';
import useClassNames, { IClassNames } from '../../hooks/classNames.hooks';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import Box from '../Box';
import Link from '../Link';
import Typography from '../Typography';

interface WidgetProps extends IClassNames {
  title: ITranslations;
  description?: ITranslations;
  ctaText?: ITranslations;
  ctaTo?: string;
  /** Omits the white box around the widget content. Use this only when you need custom styling inside the widget */
  unstyled?: boolean;
}

const Widget: React.FC<WidgetProps> = ({
  classNames,
  children,
  title,
  description,
  ctaText,
  ctaTo,
  unstyled,
}) => {
  const { className } = useClassNames(classNames);

  return (
    <div className={className}>
      <Typography variant="h2" as="h2" classNames="u-margin-bottom-xs">
        {translate(title)}
      </Typography>
      {description && (
        <Typography classNames="u-margin-bottom">{translate(description)}</Typography>
      )}
      {unstyled ? children : <Box classNames="u-margin-top">{children}</Box>}
      {ctaText && ctaTo && (
        <Link to={ctaTo} classNames="a-button u-margin-top-xs">
          {translate(ctaText)}
        </Link>
      )}
    </div>
  );
};

export default Widget;
